// extracted by mini-css-extract-plugin
export default {"progressBarContainer":"QueueDetails-progressBarContainer-wLM1D"};